// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.list-header[data-v-3bd0da2e] {\n  color: #888888;\n  font-weight: 700;\n}\n.big-title[data-v-3bd0da2e] {\n  color: #444444;\n  font-weight: 700;\n}\n", ""]);
// Exports
module.exports = exports;
